export class GetSearchCategories {
    static readonly type = '[Serch] get search categories';
}
